import { preset } from "@rebass/preset";
import { merge } from "lodash";

export const theme = merge(preset, {
  breakpoints: ["576px", "768px", "992px", "1200px", "1400px"],
});
